// Libraries
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// Components
import Dropdown from 'ui/Dropdown'
import DropdownMenu from 'ui/Dropdown/DropdownMenu'
import Text from 'ui/Text'
import Space from 'ui/Space'
import Badge from 'ui/Badge'
import Scrollable from 'ui/Scrollable'
import NotificationItem from './NotificationItem'
import Loading from 'ui/Loading'
import Divider from 'ui/Divider'
import Button from 'ui/Button'

// Icons
import IconBell from 'ui/Icons/IconBell'
import IconEmpty from 'ui/Icons/IconEmpty'

// Use
import { useDesktop } from 'use/media'

// Notifications slice
import {
  markAsReadAll,
  selectLoading,
  selectNotifications,
} from 'store/modules/notifications'

const NotificationMenu = () => {
  // Use hook
  const dispatch = useDispatch()
  const isDesktop = useDesktop()
  const notifications = useSelector(selectNotifications)

  // State
  const isLoading = useSelector(selectLoading)

  // Sort notifications
  const sortNotifications = useMemo(() => {
    return [...notifications].sort((a, b) =>
      a.createdTime < b.createdTime ? 1 : -1
    )
  }, [notifications])

  const onClickMarkAllAsRead = (e) => {
    if (!isLoading) {
      e.stopPropagation()

      dispatch(markAsReadAll())
    }
  }

  return (
    <div
      style={{
        overflow: 'hidden',
        borderRadius: 5,
        marginTop: isDesktop ? '0' : '10px',
        width: isDesktop ? '450px' : '320px',
      }}
    >
      <Scrollable maxHeight={450}>
        <Loading spinning={isLoading}>
          <Space
            style={{ width: '100%' }}
            size={5}
            direction="vertical"
            onClick={(e) => e.stopPropagation()}
          >
            {sortNotifications.length ? (
              sortNotifications.map((notification, index) => {
                const isLasted = index === sortNotifications.length - 1

                return (
                  <React.Fragment key={notification}>
                    <NotificationItem notification={notification} />
                    {notification.isRead && !isLasted && (
                      <Divider style={{ margin: 0 }} />
                    )}
                  </React.Fragment>
                )
              })
            ) : (
              <Space
                style={{ width: '100%', padding: '80px 0px' }}
                align="center"
                size={2}
                direction="vertical"
              >
                <IconEmpty />
                <Text size={15} color="#808080">
                  There isn&apos;t notifications
                </Text>
              </Space>
            )}
          </Space>
        </Loading>
      </Scrollable>
      <div
        style={{
          width: '100%',
          backgroundColor: '#838790',
          padding: '10px 20px',
        }}
      >
        <Button variant="text" onClick={onClickMarkAllAsRead}>
          <Text className="text-white" size={16}>
            Mark all as read
          </Text>
        </Button>
      </div>
    </div>
  )
}

const Notification = () => {
  const isDesktop = useDesktop()

  // Select
  const notifications = useSelector(selectNotifications)

  // Check all notifications is readed
  const isReadAllNotifications = useMemo(() => {
    return [...notifications].every((notify) => notify.isRead)
  }, [notifications])

  // Notification menu
  const dropdownMenu = () => {
    return (
      <DropdownMenu>
        <NotificationMenu />
      </DropdownMenu>
    )
  }

  return (
    <Dropdown
      overlay={dropdownMenu}
      trigger={['click']}
      arrow={isDesktop}
      placement="bottomCenter"
    >
      <div style={{ cursor: 'pointer' }}>
        <Badge
          color={'#fedd3c'}
          style={{
            display: isReadAllNotifications ? 'none' : 'block',
            boxShadow: 'none',
          }}
        >
          <IconBell width="20px" />
        </Badge>
      </div>
    </Dropdown>
  )
}

export default Notification
